const cards = [
  {
    link: "/inventory",
    label: "Инвентаризация",
    icon: "fa-user",
  },
  {
    link: "/achievements",
    label: "Достижения",
    icon: "fa-user",
    onlyVipRoles: true,
  },
  {
    link: "/cloths",
    label: "Ткани",
    icon: "fa-user",
  },
  {
    link: "/products",
    label: "Продукты",
    icon: "fa-user",
  },
  {
    link: "/cut_of_clothes",
    label: "Крой",
    icon: "fa-user",
  },
  {
    link: "/sewing_accessories",
    label: "Фурнитура",
    icon: "fa-user",
  },
  {
    link: "/stationery",
    label: "Канцелярия",
    icon: "fa-user",
  },
  {
    link: "/expendable_materials",
    label: "Расходники",
    icon: "fa-user",
  },
  {
    link: "/packages",
    label: "Упаковки",
    icon: "fa-user",
  },
  {
    link: "/promotional_products",
    label: "Рекламная продукция",
    icon: "fa-user",
  },
  {
    link: "/providers",
    label: "Поставщики",
    icon: "fa-user",
  },
  {
    link: "/clients",
    label: "Клиенты",
    icon: "fa-user",
  },
  {
    link: "/stock_movement",
    label: "Движение по складу",
    icon: "fa-arrows-h",
  },
  {
    link: "/projects",
    label: "Проекты",
    icon: "fa-dropbox",
  },
  {
    link: "/users",
    label: "Пользователи",
    icon: "fa-group",
    onlyVipRoles: true,
  },
  {
    link: "/shifts_calendars",
    label: "Календари смен",
    icon: "fa-clock-o",
    onlyVipRoles: true,
  },
  {
    link: "/login_history",
    label: "История входов",
    icon: "fa-history",
    onlyVipRoles: true,
  },
  {
    link: "/purchase_orders",
    label: "Наряд-заказы",
    icon: "fa-files-o",
  },
];

export const mainPage = {
  cards,
};



// WEBPACK FOOTER //
// ./src/user/constants/mainPage.js